/* eslint-disable no-useless-escape */
/* eslint-disable no-irregular-whitespace */
import { GeneralLayout } from '@/webapp/src/components/layout/GeneralLayout/index.js'
import { MDDoc } from '@/general/src/other/MDDoc/index.js'
import { withPageWrapper } from '@/webapp/src/lib/pageWrapper.js'

const md = `
# Согласие на обработку персональных данных

Настоящим я выражаю своё согласие Обществу с ограниченной ответственностью «СтрахоБот» (ОГРН 1256300016280, ИНН 6317170813, юридический адрес: 443004, Самарская область, г. Самара, ул. Нефтяников, д. 10А, кв. 5\) (далее — Оператор), на обработку, в том числе автоматизированную, а именно сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передачу (распространение, предоставление, доступ), обезличивание, блокирование, удаление, уничтожение следующих персональных данных:

* фамилия, имя, отчество Субъекта персональных данных;  
* адрес места жительства/пребывания или иной адрес, указанный Субъектом при заключении договоров с Оператором;  
* Паспортные данные;  
* Данные водительского удостоверения;  
* Данные автотранспорта;  
* номер мобильного телефона;  
* адрес электронной почты (email);  
* история запросов и просмотров на сайте strahobot.ru (далее — Сайт) и его сервисах;  
* файлы cookie, сведения о местоположении пользователя, сведения о действиях пользователя на Сайте, сведения об оборудовании пользователя, дата и время сессии.

Обработка персональных данных в соответствии с настоящим согласием может осуществляться Оператором в следующих целях:

* идентификация меня как субъекта персональных данных с целью заключения любых договоров с Оператором и их дальнейшего исполнения;  
* обеспечение полного функционала сайта;  
* проведение акций, опросов, интервью, тестирований и исследований на Сайте;  
* установление обратной связи, включая, но не ограничиваясь: направление мне рассылок, уведомлений в форме смс, электронных писем, устных и письменных запросов, обработки моих запросов и заявок;  
* подтверждение достоверности и полноты персональных данных, предоставленных субъектом персональных данных;  
* статистические и иные исследовательские и (или) аналитические цели при условии обезличивания моих персональных данных.

Также я соглашаюсь на обработку моих персональных данных, указанных в настоящем согласии, следующими лицами, действующими на основании поручения Оператора:

* Обществу с ограниченной ответственностью «БИОРГ» (ООО «БИОРГ» ИНН/КПП 7724396261/773101001, ОГРН 5167746501380, расположенному по адресу: 121205, г. Москва, территория Сколково инновационного центра, Большой бульвар, дом 42, стр. 1, ЭТ 0 ПОМ 137 РАБ 26 (далее — Партнёр), — в целях обеспечения полного доступа к функционалу Сайта. 

Настоящее согласие действует в течение 5 (пяти) лет с даты предоставления либо до момента отзыва мной Согласия, в зависимости от того, какое событие наступит раньше.

Настоящее согласие может быть отозвано мной путём направления уведомления посредством электронной почты на электронный адрес Оператора: manager@strahobot.ru.

Настоящее согласие подписано простой электронной подписью с использованием функционала Сайта.
`

export const DocSoglasiePage = withPageWrapper({
  title: 'Согласие на обработку персональных данных',
  Layout: GeneralLayout,
})(() => {
  return <MDDoc md={md} />
})
